import { Box, Typography } from '@mui/material';
import Balancer from 'react-wrap-balancer';
import { ReactNode } from 'react';
import { Screens } from '../../../redux/types';

type PropTypes = {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  boldedSubtitle?: string;
  text?: string;
  titleColor?: string;
  screen?: Screens;
};

export const AssessmentHeader = ({
  icon,
  title,
  subtitle,
  boldedSubtitle,
  text,
  titleColor,
  screen,
}: PropTypes) => (
  <Box
    sx={
      screen === Screens.IntroScreenOne
        ? { pt: { xs: 2 }, pb: { xs: 6 } }
        : { py: { xs: 2, sm: 3 } }
    }
  >
    {icon && <Box sx={{ mb: 1 }}>{icon}</Box>}
    <Balancer ratio={0.4}>
      <Typography
        variant={screen === Screens.IntroScreenOne ? 'h3' : 'h4'}
        component="h2"
        color={titleColor}
      >
        {title}
      </Typography>
    </Balancer>
    {subtitle && (
      <Typography variant="body1" component="h3" sx={{ pt: 1 }}>
        {subtitle}
      </Typography>
    )}
    {boldedSubtitle && (
      <Typography variant="subtitle1" component="h3" sx={{ pt: 1 }}>
        {boldedSubtitle}
      </Typography>
    )}
    {text && (
      <Typography component="p" sx={{ pt: 1, fontSize: 12 }}>
        {text}
      </Typography>
    )}
  </Box>
);
